import {createContext, useState, useEffect} from 'react';
import axios from "axios";
import {useOktaAuth} from "@okta/okta-react";

export const UserDetailsContext = createContext();

//Context that will live during the user session
export const UserDetailsProvider = ({children}) => {
    const { oktaAuth, authState } = useOktaAuth();
    const [oktaDetails, setOktaDetails] = useState({});
    const [supplierList, setSupplierList] = useState([]);
    const [systemError, setSystemError] = useState(false);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        if (!authState || !authState.isAuthenticated) return;

        async function getUserDetails() {
            //gets user details after login
            const { name, userID, userType, email, EDISupplierSelfServiceAdminGroup, GTLSUPPORTGroup, EDIAdGroups} = await oktaAuth.getUser();
            console.log("getting user from context")

            setOktaDetails({
                username: name,
                userid: userID,
                usertype: userType,
                useremail: email,
                ediItAdmin: EDIAdGroups ? true : false,
                ediCoordinator: (!EDIAdGroups && EDISupplierSelfServiceAdminGroup),
                deereStakeholder: (!EDIAdGroups && !EDISupplierSelfServiceAdminGroup && !GTLSUPPORTGroup && userType !== 'Supplier Employee'),
                supplierAccess: (userType === 'Supplier Employee') ? true : false,
                gtlSupport: (GTLSUPPORTGroup && !EDIAdGroups && !EDISupplierSelfServiceAdminGroup),
            });
            setLoading(false);
        }
        getUserDetails();
    }, [authState, oktaAuth]);


    useEffect(() => {
        if (oktaDetails.usertype === "Supplier Employee" && oktaDetails.userid) {
            const populateRelatedSuppliers = () => {
                //for supplier employees, populates related suppliers
                axios.get(process.env.REACT_APP_API_BASE_URL + "/getSupplierInfoSupplier?queryString=" + oktaDetails.userid, {
                    headers: {
                        'Authorization': 'Bearer ' + oktaAuth.getAccessToken()
                    }
                })
                    .then((response) => {
                        setSupplierList(response.data)
                    })
                    .catch((error) => {
                        setSystemError(true);
                    })
            };

            populateRelatedSuppliers();
        }
    }, [oktaDetails.usertype, oktaDetails.userid]);


    return (
        <UserDetailsContext.Provider
            value={{oktaDetails, supplierList, setSupplierList, systemError, setSystemError, loading}}>
            {children}
        </UserDetailsContext.Provider>
    );
};
